.entry {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #f5f7fb;
}

.panel {
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}

.title {
  margin: 0;
  font-size: 24px;
  text-align: center;
  font-family: var(--font-family-header);
  color: var(--color-text)
}

.subtitle {
  margin-top: 8px;
  margin-bottom: 20px;
  opacity: 0.8;
  text-align: center;
  font-family: var(--font-family-base);
}